import { BenQuery } from './BenQuery'
import { BenView } from './BenView'

export class BenSlideDown {
  static init(dones) {
    const $sw = BenQuery.query('[ben-js="slide-down"]')
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item)
    })
  }
}

function _init($sd: HTMLElement) {
  let _isOpenContent = null as null | HTMLElement
  const $itemList = BenQuery.query('.slide-item', { scope: $sd })
  $itemList.forEach(async ($item) => {
    const $title = $item.querySelector('.slide-title') as HTMLElement
    const svgHtml = `<svg class="slide-control open"><use xlink:href="#icon-add"></use></svg><svg class="slide-control fold"><use xlink:href="#icon-reduce"></use></svg>`
    BenQuery.addHtml($title, svgHtml)
    await BenQuery.nextTick()
    const $content = $item.querySelector('.slide-target') as HTMLElement
    const key = 'is-open'
    $title.addEventListener('click', () => {
      BenView.setAction('sd')
      const isOpen = $item.getAttribute(key)
      if (!isOpen || isOpen === '0') {
        BenQuery.slideDown($content)
        $item.setAttribute(key, '1')
      } else {
        BenQuery.slideUp($content)
        $item.setAttribute(key, '0')
      }
      $itemList.forEach(($item1) => {
        if ($item1 === $item) return
        const isOpen1 = $item1.getAttribute(key)
        if (isOpen1 === '1') {
          const $content1 = $item1.querySelector('.slide-target') as HTMLElement
          BenQuery.slideUp($content1)
          $item1.setAttribute(key, '0')
        }
      })
    })
  })
}
